<template>
<div class="collection-list" v-cloak>
  <!-- 微信认证组件 -->
  <wxAuth :share="share"></wxAuth>
  <div class="home-header">
    <!-- title -->
    <headers :params="hraderP"></headers>
  </div>
  <img src="../../assets/images/hjindxbj.png" alt="" :class="['top-banner',{'app':isApp}]">
  <!-- 方案合集列表 -->
  <div v-show="!noData && list.length > 0">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :offset="80"
      @load="onLoad"
    >
      <div class="list-content">
        <van-row class="list-item" v-for="(item, index) of list" :key="index">
          <router-link :to="`/collection/detail.html?id=${item.id}`">
            <img :src="item.pic" alt="" class="main-img">
            <span class="count-box">{{item.count}}个方案</span>
            <div class="main-txt">
              <p class="title">{{item.name}}</p>
              <p class="description">{{item.description}}</p>
              <p class="view-count"><img src="../../assets/images/readicon.png" alt=""><span>{{item.viewCount}}阅读</span></p>
            </div>
          </router-link>
        </van-row>
      </div>
    </van-list>
  </div>
  <toTopCollection></toTopCollection>
  <router-link to="/index.html"><img src="../../assets/images/hjinexenter.png" alt="" class="to-index"></router-link>
  <noResult v-show="noData && list.length < 0 && list.length == 0"  @toListSelf="toListSelf"></noResult>
</div>
</template>

<script>
import headers from '@/components/headers'
import wxAuth from '@/components/wxAuth'
import { collectionList } from '@/api/collection/collection'
import noResult from '@/components/noResult'
import toTopCollection from '@/components/toTopCollection'
export default {
  name: 'collection-list',
  components: { headers, wxAuth, noResult, toTopCollection },
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '河姆渡精选方案合集',
        lefticon: true
      },
      loading: false,
      finished: false,
      noData: false,
      paramsData: {
        current: 1,
        size: 5
      },
      list: [],
      isApp: true

    }
  },
  created () {
    this.isApp = !!(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
    this.getData()
  },
  methods: {
    toListSelf () {
      this.getData()
    },
    onLoad () {
      // 调用查询接口
      collectionList(this.paramsData).then(result => {
        if (result.status !== 200) {
          this.loading = false
          this.finished = true
          return false
        }
        if (result.data.respCode !== '0000') {
          this.loading = false
          this.finished = true
          return false
        }
        this.paramsData.current += 1
        this.list = this.list.concat(result.data.data.records)
        this.loading = false
        if (this.list.length === result.data.data.total || this.list.length > result.data.data.total) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.paramsData.total = 0
      })
    },
    getData () {
      this.paramsData.current = 1
      this.paramsData.size = 5
      this.finished = false
      this.noData = false
      this.onLoad()
    }
  }
}
</script>

<style scoped lang="scss">
  .collection-list{
    background-color: #F5F5F5;
    .home-header{
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 9;
    }
    .top-banner{
      width: 100%;
      margin-top: 45px;
    }
    .top-banner.app{
      margin-top: 0;
    }
    .list-content{
      margin-top: -32px;
      margin-right: 10px;
      margin-left: 10px;
      background-color: #F5F5F5;
      .list-item{
        position: relative;
        margin-bottom: 10px;
        .main-img{
          width: 100%;
          box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.1);
          border-radius: 12px 12px 0 0;
        }
        .count-box{
          height: 23px;
          line-height: 23px;
          background: #2F7BFF;
          box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.1);
          border-radius: 12px;
          color: #FFFFFF;
          padding-left: 10px;
          padding-right: 10px;
          position: absolute;
          top: 13px;
          right: 10px;
        }
        .main-txt{
          background-color: #FFFFFF;
          padding: 15px;
          .title{
            font-size: 17px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 17px;
            text-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
            height: 19px;
            line-height: 19px;
            border-left: 3px solid #2F7BFF;
            padding-left: 10px;
            display: -webkit-box;
        　　-webkit-box-orient: vertical;
        　　-webkit-line-clamp: 1;
        　　overflow: hidden;
          }
          .description{
            margin-top: 12px;
            margin-bottom: 8px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
            line-height: 17px;
            text-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
            display: -webkit-box;
        　　-webkit-box-orient: vertical;
        　　-webkit-line-clamp: 4;
        　　overflow: hidden;
          }
          .view-count{
            position: relative;
            text-align: right;
            font-size: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
            line-height: 10px;
            text-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
            span{
              display: inline-block;
              padding-left: 14px;
            }
            img{
              width: 10px;
              margin-right: 4px;
              position: absolute;
              top: -1px;

            }
          }
        }
      }
    }
    .to-top{
      width: 34px;
      position: fixed;
      right: 10px;
      bottom: 55px;
    }
    .to-index{
      width: 122px;
      position: fixed;
      right: 10px;
      bottom: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/collection/list.vue